import React from "react";
import { Oval, Style } from "react-loader-spinner";

export function LoadingSpinner({
    height,
    width,
    color,
    secondaryColor,
    ariaLabel,
    strokeWidth,
    wrapperStyle,
    wrapperClass,
}: {
    height?: number;
    width?: number;
    color?: string;
    secondaryColor?: string;
    ariaLabel?: string;
    strokeWidth?: number;
    wrapperStyle?: Style;
    wrapperClass?: string;
}) {
    return (
        <div className="loader-bg spinner-flex-center">
            <Oval
                height={height ? height : 40}
                width={width ? width : 40}
                color={color ? color : "#0037ff"}
                secondaryColor={secondaryColor ? secondaryColor : "#ebebeb"}
                ariaLabel={ariaLabel ? ariaLabel : "oval-loading"}
                strokeWidth={strokeWidth ? strokeWidth : 5}
                wrapperStyle={wrapperStyle}
                wrapperClass={wrapperClass ? wrapperClass : ""}
            />
        </div>
    );
}
